<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/product/visual-banner.png" alt="">
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="">
        <span>首页 > 产品与解决方案>数据可视化解决方案</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <div style="margin-bottom: 10px;">方案概述</div>
      <p>随着银行业的不断深入发展，传统的经营管理决策体系已经不能满足业务不断拓展的需要及监管需求，急需建立综合、
全面、高效、及时、直观的管理决策系统，展现业务经营管理状况，利用数字化技术多维度分析展示经营状况，建立更
加科学高效智能的决策体系。管理驾驶舱系统，可视化呈现金融机构业务分析、经营分析、运营分析、生产分析、监管
合规、风险控制、市场跟进、普惠金融等多角度指标，搭建基于高层战略决策的指标框架，让管理者多维度、实时、精
确把握经营现状，快速分析变化因素，推进敏捷决策执行。</p>
      <div class="title">基础架构</div>
     <div>
        <img src="../assets/product/visual1.png" alt="">
      </div> 
      <!-- 优势简介 -->
      <div class="advantage">
          <div class="ad-title">优势简介</div>
          <div>
        <img src="../assets/product/visual2.png" alt="">
      </div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
    
    };
  },
  mounted() {
   
    
  },
  computed: {},
  methods: {
    
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;
  .section{
    margin: 0 0 -5px;
    position: relative;
    color: #FFFFFF;
    cursor: pointer;
    img{
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips{
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div{
      margin-left: 12%;
      img{
      width: 12px;
      height: 12px;
      vertical-align: middle;

    }
    span{
      font-size: 10px;
      color: #808080;
      margin: 0 6px;
      display: inline-block;
      vertical-align: middle;
      }
    }
    
  }
  // 整体内容
  .main{
    width: 100%;
    background: #F5F5FA;
    text-align: center;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405C80;
    padding: 60px 0;
    box-sizing: border-box;
    font-size: 28px;
    cursor: pointer;
    .title{
      margin: 60px auto;
    }
    p{
      color: #8D9BB9;
      font-size: 20px;
      width: 80%;
      margin: 20px auto 0;
      text-align: left;
    }
    img{
      width: 55%;
      height: auto;
    }
    // 优势简介
    .advantage{
        background: #FFFFFF;
        padding: 40px 0;
        margin: 40px 0 0;
        .ad-title{
            margin-bottom: 20px;
        }
    }
  }
}
</style>
